import styled from "styled-components";
import { colorPrimary, colorSecondary, hex2rgba } from "../../colors";
import { BreakPoints, ContentWidths } from "../../constants";

export const StyledGridCarousel = styled.section.attrs({
  className: "grid-carousel"
})`
  display: flex;
  flex-direction: column;
  width: 100%;
  color: ${colorSecondary};
  align-items: center;

  @media (min-width: ${BreakPoints.lg}) {
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
  }

  .gc-cards {
    display: flex;
    flex-direction: column;

    @media (min-width: ${BreakPoints.sm}) {
      width: ${ContentWidths.sm};
    }

    @media (min-width: ${BreakPoints.lg}) {
      margin-right: 80px;
      width: 465px;
    }

    @media (min-width: ${BreakPoints.xl}) {
      width: 555px;
    }
  }
  
  .gc-card {

    &--inactive {
      display: none;
    }

    &__title-row {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }

    &__arrow {
      background: none;
      padding: 8px 16px;
      margin: 8px 0;
      color: ${hex2rgba(colorSecondary, 0.3)};
      border: none;
      font: inherit;
      cursor: pointer;
      outline: inherit;

      &:first-child {
        border-right: 1px solid ${hex2rgba(colorSecondary, 0.18)};
      }
    }

    &__title {
      font-family: Kapra Neue Pro;
      text-transform: uppercase;
      font-size: 3rem;
      font-weight: normal;
      margin: 0 8px;
      padding-top: 4px;
    }

    &__description {
      font-family: Rubik;
      letter-spacing: 0.025em;
      color: ${hex2rgba(colorSecondary, 0.6)};
      margin: 0 0 36px 0;
    }

    &__highlights {
      padding: 0;
      margin: 0 0 36px 0;
    }

    &__highlight {
      font-family: Pitch Sans Bold;
      font-size: 0.8125rem;
      list-style-type: none;
      margin: 0 0 13px 0;
      padding: 2px 8px;
      background-color: ${colorPrimary};

      @media (min-width: ${BreakPoints.sm}) {
        width: fit-content;
      }
    }
  }

  .gc-icons {
    display: flex;
    flex-wrap: wrap;

    @media (min-width: ${BreakPoints.sm}) {
      width: ${ContentWidths.sm};
    }

    @media (min-width: ${BreakPoints.lg}) {
      width: 465px;
    }
  }

  .gc-icon {
    flex: 1 0 47%;
    aspect-ratio: 1 / 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${hex2rgba(colorSecondary, 0.05)};
    margin: 2px;
    cursor: pointer;
    transition: all .2s ease-in-out;

    &:hover,
    &:active {
      box-shadow: inset 0 0 0 4px ${colorPrimary};
      transition: all .2s ease-in-out;
    }
    
    @media (min-width: ${BreakPoints.lg}) {
      max-width: 255px;
    }

    &__title {
      font-family: Pitch Sans Bold;
      font-size: 0.8125rem;
      text-transform: uppercase;
      color: ${hex2rgba(colorSecondary, 0.6)};
      letter-spacing: .2em;

      &--top {
        margin: -32px 0 24px 0;
      }
      &--bottom {
        margin: 32px 0 -24px 0;
      }
    }

    &__img {
      opacity: 0.3;
    }

    &--active {
      background-color: ${colorPrimary};
      & > .gc-icon__img {
        opacity: 1;
      }
    }
  }

`;
